export default class CollectionType {
  static get Desktop () { return 'desktop' }
  static get Mobile () { return 'mobile' }
  static get Crm () { return 'crm' }

  static getName (enumValue) {
    switch (enumValue) {
      case CollectionType.Desktop:
        return 'Сайт'

      case CollectionType.Mobile:
        return 'Мобильное приложение'

      case CollectionType.Crm:
        return 'CRM'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      CollectionType.Desktop,
      CollectionType.Mobile,
      CollectionType.Crm,
    ]

    return variants.map(item => ({
      id: item,
      value: item,
      name: CollectionType.getName(item),
    }))
  }
}
